<section class="section">
  <h3>{{ "Services.Tags" | translate }}</h3>
  @if (hasTags()) {
    <div class="checktag__flex">
      @for (tag of collectedTags(); track tag) {
        <checktag checktagTitle="{{ tag }}" />
      }
    </div>
  }
</section>
